import type { IdentityChipTone } from './IdentityChip';

// Monday-driven account types - the set can grow, so unknown values (and
// "Select") intentionally fall back to the neutral tone rather than erroring
// or defaulting to a color that implies a category they don't fit.
// Lives outside IdentityChip.tsx so that file only exports components
// (react-refresh/only-export-components).
const ACCOUNT_TYPE_TONES: Record<string, IdentityChipTone> = {
    concierge: 'teal',
    vivos: 'blue',
    'vivos csam': 'blue',
    adjunct: 'amber',
    'adjunct w/o odo pricing (gpo)': 'amber'
};

export function accountTypeTone(accountType: string): IdentityChipTone {
    return ACCOUNT_TYPE_TONES[accountType.trim().toLowerCase()] ?? 'neutral';
}
